import { GenericLabel } from '@com-delta-idp/mnx-utils';
import {
  CardCarouselBanner,
  BannerImage
} from '../../models/banner.interfaces';

export const BannerImageDinersClubCardMocks: BannerImage = {
  alt: 'Delta SkyMiles Diners Club Card',
  src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/japan-diners-club-card.png',
  show: true,
  position: 'right'
};

export const BannerContentDinersClubCardMocks: GenericLabel = {
  title: 'Delta SkyMiles Diners Club Card',
  subtitle: ''
};

export const BannerDinersClubCardMocks: CardCarouselBanner = {
  labels: BannerContentDinersClubCardMocks,
  image: BannerImageDinersClubCardMocks
};
